"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CorroderSuits = void 0;
const Tags_1 = require("../Tags");
const CardType_1 = require("../CardType");
const Resources_1 = require("../../Resources");
const ResourceType_1 = require("../../ResourceType");
const SelectCard_1 = require("../../inputs/SelectCard");
const CardName_1 = require("../../CardName");
const CardRenderer_1 = require("../render/CardRenderer");
const Card_1 = require("../Card");
class CorroderSuits extends Card_1.Card {
    constructor() {
        super({
            name: CardName_1.CardName.CORRODER_SUITS,
            cardType: CardType_1.CardType.AUTOMATED,
            tags: [Tags_1.Tags.VENUS],
            cost: 8,
            metadata: {
                cardNumber: '219',
                description: 'Increase your M€ production 2 steps. Add 1 resource to ANY Venus CARD.',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.production((pb) => {
                        pb.megacredits(2);
                    }).wild(1).secondaryTag(Tags_1.Tags.VENUS);
                }),
            },
        });
    }
    ;
    play(player) {
        player.addProduction(Resources_1.Resources.MEGACREDITS, 2);
        const cards = CorroderSuits.getVenusResCards(player);
        if (cards.length === 0)
            return undefined;
        if (cards.length === 1) {
            player.addResourceTo(cards[0], { log: true });
            return undefined;
        }
        return new SelectCard_1.SelectCard('Select card to add 1 resource', 'Add resource', CorroderSuits.getVenusResCards(player), (foundCards) => {
            player.addResourceTo(foundCards[0], { log: true });
            return undefined;
        });
    }
    static getVenusResCards(player) {
        let resourceCards = player.getResourceCards(ResourceType_1.ResourceType.FLOATER);
        resourceCards = resourceCards.concat(player.getResourceCards(ResourceType_1.ResourceType.MICROBE));
        resourceCards = resourceCards.concat(player.getResourceCards(ResourceType_1.ResourceType.ANIMAL));
        return resourceCards.filter((card) => card.tags.includes(Tags_1.Tags.VENUS));
    }
}
exports.CorroderSuits = CorroderSuits;
//# sourceMappingURL=CorroderSuits.js.map